module.exports = __webpack_public_path__ + "media/images/favicons/favicon-bfe3d43d17aa475fe6d1ecd2dafc05e0.ico";